export default __webpack_public_path__ + "static/media/media.2dd30816.png";